import PeriodValueFormulaNode from "./PeriodValueFormulaNode.js";

/**
 * `changeFormulaNode` is a concrete implementation of `periodValueFormulaNode`
 * representing a group change node.
 */

/**
 * TODO: write documentation
 */
export default class ChangeFormulaNode extends PeriodValueFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitChangeNode(this, additionalInformation);
	}

	static getType() {
		return "ChangeNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildPeriodValueNode(this, additionalInformation);
	}
}
